import { IconComponentProps } from '@nexelem/icons';
import { FC, ReactNode } from 'react';
import { GridColumnHeaderTitle } from '@mui/x-data-grid-pro';
import { IconButton } from '@nexelem/components';
import { Popper } from '@nexelem/popper';
import { ProLightCircleQuestion } from '@nexelem/icons/ProLightCircleQuestion';

interface HeaderWithIconProps {
  headerText: string;
  columnWidth: number;
}

interface HeaderWithHelpIconProps extends HeaderWithIconProps {
  helperText: ReactNode;
}

interface HeaderWithStartIconProps extends HeaderWithIconProps {
  Icon: FC<IconComponentProps>;
}

const HeaderWithHelpIcon: FC<HeaderWithHelpIconProps> = ({ headerText, helperText, columnWidth }) => (
  <>
    <GridColumnHeaderTitle label={headerText} {...{ columnWidth }}></GridColumnHeaderTitle>
    <Popper content={helperText} openingElement={<IconButton Icon={ProLightCircleQuestion} />} />
  </>
);

export const headerCellWithHelpIcon = (props: HeaderWithHelpIconProps) => () => <HeaderWithHelpIcon {...props} />;

const HeaderWithStartIcon: FC<HeaderWithStartIconProps> = ({ headerText, Icon, columnWidth }) => (
  <div className="flex items-center gap-2">
    <Icon />
    <GridColumnHeaderTitle label={headerText} {...{ columnWidth }}></GridColumnHeaderTitle>
  </div>
);

export const headerCellWithStartIcon = (props: HeaderWithStartIconProps) => () => <HeaderWithStartIcon {...props} />;
